// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- MenuHeaderLeft.css --- */

.dropdownMenu {
    position: relative;
    z-index: 101; 
}

.dropdownMenu-title {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    margin: 5px;
    font-weight: 500;
    /* Transición de color se mantiene */
    transition: color 0.2s ease;
}

/* Colores ACTIVO / HOVER (Naranja/Melocotón) */
.dropdownMenu-title:hover, .dropdownMenu-title.active {
    background-color: #ececec; /* Fondo muy claro (casi blanco con tinte naranja) */
    color: #222; /* Texto Naranja */
    /* border: 1px solid #bbb; */
    border-radius: 8px;
}

.dropdownMenu-icon {
    transition: transform 0.25s ease;
}

.dropdownMenu-icon.open {
    transform: rotate(180deg);
}

/* ------------------------------------------- */
/* ESTILO LIQUID GLASSY / VIDRIO ESMERILADO    */
/* ------------------------------------------- */
.dropdownMenu-content {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    min-width: 220px;
    
    /* Fondo semi-transparente necesario para el efecto */
    background-color: rgba(255, 255, 255, 0.7); 
    
    /* PROPIEDAD CLAVE: El filtro de desenfoque aplicado al fondo */
    backdrop-filter: blur(12px) saturate(180%);
    -webkit-backdrop-filter: blur(12px) saturate(180%); /* Para compatibilidad con Safari */
    
    /* Sombra más suave y moderna */
    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15); 
    
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.3); /* Borde sutil */

    padding: 8px 0;
    opacity: 0;
    transform: translateY(4px);
    pointer-events: none;
    transition: opacity .3s ease, transform .3s ease;
    z-index: 9999;
}

.dropdownMenu-content.open {
    display: block;
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
    margin-top: 2px;
}
/* ------------------------------------------- */

.dropdownMenu-item {
    display: block;
    padding: 5px 10px;
    margin: 3px 5px;
    text-decoration: none;
    color: #333;
    transition: background-color 0.15s ease, color 0.15s ease;
    border-radius: 0;
}

/* Colores HOVER del ITEM (Adaptado al esquema naranja) */
.dropdownMenu-item:hover {
    /* Usamos el mismo color claro del active/hover del título */
    background-color: #ececec; 
    color: #222; /* Texto Naranja */
    /* Importante: Si quieres esquinas redondeadas en el item, tendrías que quitárselas al border-radius: 0; */
    border-radius: 8px !important;
}

/* En el estilo Glassy, no es común usar divisores de línea */
/* Si quieres mantenerlos: */
.dropdownMenu-item + .dropdownMenu-item {
    border-top: 1px solid rgba(238, 238, 238, 0.6); /* Color más sutil */
}

/* Nueva clase para el contenedor de navegación (si estás usando el componente React modificado) */
.menu-navigation-container {
    background-color: #fff; /* No fondo blanco por defecto */
    display: flex;
    align-items: center;
    min-height: 100%; 
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/Admin/MenuHeaderLeft.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;IACI,yBAAyB,EAAE,oDAAoD;IAC/E,WAAW,EAAE,kBAAkB;IAC/B,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gDAAgD;AAChD,gDAAgD;AAChD,gDAAgD;AAChD;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;;IAEhB,qDAAqD;IACrD,0CAA0C;;IAE1C,+DAA+D;IAC/D,0CAA0C;IAC1C,kDAAkD,EAAE,mCAAmC;;IAEvF,+BAA+B;IAC/B,4CAA4C;;IAE5C,mBAAmB;IACnB,0CAA0C,EAAE,gBAAgB;;IAE5D,cAAc;IACd,UAAU;IACV,0BAA0B;IAC1B,oBAAoB;IACpB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;AACnB;AACA,gDAAgD;;AAEhD;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,yDAAyD;IACzD,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,4DAA4D;IAC5D,yBAAyB;IACzB,WAAW,EAAE,kBAAkB;IAC/B,0GAA0G;IAC1G,6BAA6B;AACjC;;AAEA,6DAA6D;AAC7D,4BAA4B;AAC5B;IACI,8CAA8C,EAAE,oBAAoB;AACxE;;AAEA,kGAAkG;AAClG;IACI,sBAAsB,EAAE,gCAAgC;IACxD,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;AAC1C","sourcesContent":["/* --- MenuHeaderLeft.css --- */\n\n.dropdownMenu {\n    position: relative;\n    z-index: 101; \n}\n\n.dropdownMenu-title {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 10px;\n    margin: 5px;\n    font-weight: 500;\n    /* Transición de color se mantiene */\n    transition: color 0.2s ease;\n}\n\n/* Colores ACTIVO / HOVER (Naranja/Melocotón) */\n.dropdownMenu-title:hover, .dropdownMenu-title.active {\n    background-color: #ececec; /* Fondo muy claro (casi blanco con tinte naranja) */\n    color: #222; /* Texto Naranja */\n    /* border: 1px solid #bbb; */\n    border-radius: 8px;\n}\n\n.dropdownMenu-icon {\n    transition: transform 0.25s ease;\n}\n\n.dropdownMenu-icon.open {\n    transform: rotate(180deg);\n}\n\n/* ------------------------------------------- */\n/* ESTILO LIQUID GLASSY / VIDRIO ESMERILADO    */\n/* ------------------------------------------- */\n.dropdownMenu-content {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    min-width: 220px;\n    \n    /* Fondo semi-transparente necesario para el efecto */\n    background-color: rgba(255, 255, 255, 0.7); \n    \n    /* PROPIEDAD CLAVE: El filtro de desenfoque aplicado al fondo */\n    backdrop-filter: blur(12px) saturate(180%);\n    -webkit-backdrop-filter: blur(12px) saturate(180%); /* Para compatibilidad con Safari */\n    \n    /* Sombra más suave y moderna */\n    box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.15); \n    \n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.3); /* Borde sutil */\n\n    padding: 8px 0;\n    opacity: 0;\n    transform: translateY(4px);\n    pointer-events: none;\n    transition: opacity .3s ease, transform .3s ease;\n    z-index: 9999;\n}\n\n.dropdownMenu-content.open {\n    display: block;\n    opacity: 1;\n    transform: translateY(0);\n    pointer-events: auto;\n    margin-top: 2px;\n}\n/* ------------------------------------------- */\n\n.dropdownMenu-item {\n    display: block;\n    padding: 5px 10px;\n    margin: 3px 5px;\n    text-decoration: none;\n    color: #333;\n    transition: background-color 0.15s ease, color 0.15s ease;\n    border-radius: 0;\n}\n\n/* Colores HOVER del ITEM (Adaptado al esquema naranja) */\n.dropdownMenu-item:hover {\n    /* Usamos el mismo color claro del active/hover del título */\n    background-color: #ececec; \n    color: #222; /* Texto Naranja */\n    /* Importante: Si quieres esquinas redondeadas en el item, tendrías que quitárselas al border-radius: 0; */\n    border-radius: 8px !important;\n}\n\n/* En el estilo Glassy, no es común usar divisores de línea */\n/* Si quieres mantenerlos: */\n.dropdownMenu-item + .dropdownMenu-item {\n    border-top: 1px solid rgba(238, 238, 238, 0.6); /* Color más sutil */\n}\n\n/* Nueva clase para el contenedor de navegación (si estás usando el componente React modificado) */\n.menu-navigation-container {\n    background-color: #fff; /* No fondo blanco por defecto */\n    display: flex;\n    align-items: center;\n    min-height: 100%; \n    border-radius: 10px;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
